import {Component,Renderer2, ElementRef, ViewChildren, QueryList, EventEmitter, Inject, Input, OnChanges, OnInit, Output, ViewChild} from '@angular/core';
import {ConfService} from '../conf.service';
import {Loggedin} from '../authFilter/platformCentralAuth';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatMenuTrigger, MatSnackBar} from '@angular/material';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {WebsocketService} from '../websocket.service';
import {FormControl} from '@angular/forms';
import {interval} from 'rxjs';
import {environment} from '../../environments/environment';
import {AlertService} from '../alert.service';
import {AppComponent} from '../app.component';
import {Router} from '@angular/router';
import {LeftpanelListenerService} from '../leftpanel-listener.service';
import {SnackbarComponent} from '../snackbar/snackbar.component';
import {AccountInfoService} from '../user/account-info.service';
import {AuthService} from '../user/auth.service';
import {AuthedApiService} from '../authed-api.service';
import {AdminEnvironmentHandlerService} from '../admin-environment-handler.service';
import {AuditLogService} from '../audit-log.service';

export interface Server {
    name: string;
    subName: string;
    active: boolean;
    disabled: boolean;
    link: string;
}

@Component({
    selector: 'app-header-ribbon',
    templateUrl: './header-ribbon.component.html',
    styleUrls: ['./header-ribbon.component.scss']
})
export class HeaderRibbonComponent implements OnInit, OnChanges {

    @ViewChild('notificationMenuTrigger') trigger: MatMenuTrigger;
    availableEnvironmentsToSwitch = [];
    notificationCount = 0;
    notificationMessages: any;

    @ViewChild('notificationSideBar_tag') notificationSideBarRef: ElementRef;
    notificationSideBar: any;
    mode = new FormControl('over');

    @Input() isSignUp: boolean;
    @Input() ribbon = '';
    @Input() isUserLoggedIn: string;

    settingsLoading = true;
    serverStatusLoading = true;
    serverStatusData: Server[] = [];
    settingsData: any;
    notificationList: any = [];

    @Input() isServerStatusPanelOpened = false;
    @Output() isServerStatusPanelStateChanged: EventEmitter<any> = new EventEmitter<any>();
    @Output() isPartnerInfoStatusPanelStateChanged: EventEmitter<any> = new EventEmitter<any>();
    @Input() isNotificationPanelOpened = false;
    @Input() isPartnerInfoPanelOpened = false;
    @Input() isAlertsPanelOpened = false;
    @Output() isAlertsPanelStateChanged: EventEmitter<any> = new EventEmitter<any>();
    @Output() isNotificationPanelStateChanged: EventEmitter<any> = new EventEmitter<any>();

    menus = [
        {
            validOn: 'admin',
            stickyMenus: [
                {
                    name: 'administration',
                    displayName: 'Admin',
                    tooltipText: 'Administration of environments, tools and infrastructure',
                    hasSubMenu: false,
                    route: '/administration',
                    displayType: 'block',
                    icon: 'fa fa-cogs',
                },
                // {
                //     name: 'infrastructure',
                //     displayName: 'Infra',
                //     tooltipText: 'Infrastructure Settings',
                //     hasSubMenu: true,
                //     displayType: 'block',
                //     icon: 'fa fa-building',
                //     submenus: [
                //         {
                //             categoryName: 'Cloud Platforms',
                //             route: '/cloudplatforms',
                //             icon: 'fa fa-cloud'
                //         },
                //         {
                //             categoryName: 'Environments',
                //             route: '/environment-settings',
                //             icon: 'fa fa-code-fork'
                //         },
                //         {
                //             categoryName: 'Secrets Managers',
                //             route: '/logging-settings',
                //             icon: 'fa fa-user-secret'
                //         },
                //         {
                //             categoryName: 'Gateway Managers',
                //             route: '/gateways',
                //             icon: 'fa fa-shield'
                //         },
                //         {
                //             categoryName: 'Databases',
                //             route: '/databases',
                //             icon: 'fa fa-database'
                //         }
                //     ]
                // },
                // {
                //     name: 'authorization',
                //     displayName: 'Auth',
                //     tooltipText: 'Authorize access of APIs',
                //     hasSubMenu: true,
                //     displayType: 'block',
                //     icon: 'fa fa-lock',
                //     submenus: [
                //         {
                //             categoryName: 'Roles',
                //             route: '/roles',
                //             icon: 'fa fa-id-card-o'
                //         },
                //         {
                //             categoryName: 'Permission Groups',
                //             route: '/permissiongroups',
                //             icon: 'fa fa-key'
                //         },
                //         {
                //             categoryName: 'Permissions',
                //             route: '/permissions',
                //             icon: 'fa fa-checksquare-o'
                //         },
                //         {
                //             categoryName: 'User Groups',
                //             route: '/usergroups',
                //             icon: 'fa fa-users'
                //         },
                //         {
                //             categoryName: 'Users',
                //             route: '/users',
                //             icon: 'fa fa-user'
                //         }
                //     ]
                // },
                {
                    name: 'partner settings',
                    displayName: 'Settings',
                    tooltipText: 'Partner specific settings',
                    hasSubMenu: true,
                    displayType: 'block',
                    icon: 'fa fa-cog',
                    submenus: [
                        // {
                        //     categoryName: 'Accounts',
                        //     route: '/accounts',
                        //     icon: 'fa fa-user-plus'
                        // },
                        {
                            categoryName: 'Business Locations',
                            route: '/businesslocations',
                            icon: 'fa fa-globe'
                        },
                        {
                            categoryName: 'Business Details',
                            route: '/businessdetails',
                            icon: 'fa fa-building-o'
                        },
                        {
                            categoryName: 'Branding',
                            route: '/usergroups',
                            icon: 'fa fa-id-badge'
                        },
                        {
                            categoryName: 'Themes',
                            route: '/themes',
                            icon: 'fa fa-themeisle'
                        },
                        // {
                        //     categoryName: 'Gateway',
                        //     route: '/gateways',
                        //     icon: 'fa fa-key'
                        // },
                        {
                            categoryName: 'Security',
                            route: '/permissions',
                            icon: 'fa fa-shield'
                        },
                        {
                            categoryName: 'BOT',
                            route: '/usergroups',
                            icon: 'fa fa-commenting-o'
                        },
                        {
                            categoryName: 'API Creators',
                            route: '/users',
                            icon: 'fa fa-plus'
                        },
                        {
                            categoryName: 'API Transformers',
                            route: '/users',
                            icon: 'fa fa-exchange'
                        },
                        {
                            categoryName: 'API Integrators',
                            route: '/users',
                            icon: 'fa fa-user'
                        },
                        {
                            categoryName: 'API Management',
                            route: '/apimanagement',
                            icon: 'fa fa-cog'
                        },
                        {
                            categoryName: 'Manage Email Configurations',
                            route: '/email-settings',
                            icon: 'fa fa-cog'
                        },
                        {
                            categoryName: 'Idle Timeout Settings',
                            route: '/idle-timeout',
                            icon: 'fa fa-clock-o'
                        }
                        // {
                        //     categoryName: 'Developer Experience',
                        //     route: '/devex',
                        //     icon: 'fa fa-rocket'
                        // }
                    ]
                },
                {
                    name: 'billing',
                    displayName: 'Billing',
                    tooltipText: 'Billing',
                    hasSubMenu: false,
                    route: '/billing',
                    displayType: 'block',
                    icon: 'fa fa-usd',
                }
                // {
                //     name: 'billing',
                //     displayName: 'Billing',
                //     tooltipText: 'Billing Details',
                //     hasSubMenu: true,
                //     displayType: 'block',
                //     icon: 'fa fa-lock',
                //     submenus: [
                //         {
                //             categoryName: 'Billing',
                //             route: '/billing',
                //             icon: 'fa fa-usd'
                //         },
                //         {
                //             categoryName: 'Payments',
                //             route: '/permissiongroups',
                //             icon: 'fa fa-credit-card-alt'
                //         },
                //         // {
                //         //     categoryName: 'Invoices',
                //         //     route: '/permissions',
                //         //     icon: 'fa fa-files-o'
                //         // },
                //         // {
                //         //     categoryName: 'Subscriptions',
                //         //     route: '/usergroups',
                //         //     icon: 'fa fa-ticket'
                //         // },
                //         {
                //             categoryName: 'Coupons',
                //             route: '/users',
                //             icon: 'fa fa-money'
                //         },
                //         {
                //             categoryName: 'Credits',
                //             route: '/users',
                //             icon: 'fa fa-credit-card'
                //         }
                //     ]
                // }
            ]

        },
        {
            validOn: 'environments',
            stickyMenus: [
                {
                    name: 'control-plane',
                    displayName: 'Control Plane',
                    tooltipText: 'Control Plane',
                    hasSubMenu: false,
                    route: '/controlplane',
                    displayType: 'block',
                    icon: 'fa fa-image',
                    permission: 'MENU_CREATE_NAVIGATION_PANE'
                },
                {
                    name: 'api-discovery',
                    displayName: 'API Discovery',
                    tooltipText: 'Discover APIs',
                    hasSubMenu: false,
                    route: '/discover',
                    displayType: 'block',
                    icon: 'fa fa-search',
                    permission: 'MENU_API_DISCOVERY'
                },
                {
                    name: 'reference',
                    displayName: 'Reference',
                    tooltipText: 'API Reference',
                    hasSubMenu: false,
                    route: '/docs',
                    displayType: 'block',
                    icon: 'fa fa-file-code-o',
                    permission: 'MENU_API_REFERENCE'
                },
                {
                    name: 'alerts',
                    displayName: 'Alerts',
                    tooltipText: 'Platform and Application Alerts',
                    hasSubMenu: false,
                    route: '/alerts',
                    displayType: 'block',
                    icon: 'fa fa-bell',
                    permission: 'MENU_ALERTS'
                },
                {
                    name: 'monitors',
                    displayName: 'Monitors',
                    tooltipText: 'API Monitoring',
                    hasSubMenu: false,
                    route: '/monitors',
                    displayType: 'block',
                    icon: 'fa fa-bar-chart',
                    permission: 'MENU_MONITORS'
                },
                {
                    name: 'journey',
                    displayName: 'Journey',
                    tooltipText: 'Journey Analytics',
                    hasSubMenu: false,
                    route: '/journey',
                    displayType: 'block',
                    icon: 'fa fa-line-chart',
                    permission: 'MENU_JOURNEY_ANALYTICS'
                },
                // {
                //     name: 'partner-info',
                //     displayName: 'Partner Info',
                //     tooltipText: 'Partner Info',
                //     hasSubMenu: true,
                //     displayType: 'block',
                //     icon: 'fa fa-info',
                //     submenu: []
                // },
            ]
        }
    ];
    partnerInfo = [];
    subMenu = false;

    partnerShortCode: any = '';
    allEnvironments: any = [];
    isEnvironmentSwitchLoading = true;

    constructor(private confPost: ConfService,
                private router: Router,
                public appComponent: AppComponent,
                private snackBar: MatSnackBar,
                private auth: Loggedin,
                public authService: AuthService,
                private auditLog: AuditLogService,
                private dialog: MatDialog,
                public platform: LeftpanelComponent,
                public alertService: AlertService,
                public websocketService: WebsocketService,
                public accountInfoService: AccountInfoService,
                public leftpanelListner: LeftpanelListenerService,
                public authedAPIService: AuthedApiService,
                public adminEnvironmentHandler: AdminEnvironmentHandlerService
    ) {
    }

    openSnackBar(message: string, panelClass: string, config: any) {
        let snackBarConfigs: any;
        if (config !== null && config !== undefined && config !== '') {
            snackBarConfigs = config;
            snackBarConfigs['data'] = message;
            snackBarConfigs['panelClass'] = panelClass;
        } else {
            snackBarConfigs = {
                data: message,
                verticalPosition: 'top',
                horizontalPosition: 'center',
                panelClass: panelClass,
                duration: 30000
            };
        }
        this.snackBar.openFromComponent(SnackbarComponent, snackBarConfigs);
        // this.snackBar.openFromComponent(SnackbarComponent, {
        //     data: message,
        //     verticalPosition: 'top',
        //     horizontalPosition: 'center',
        //     panelClass: panelClass,
        //     duration: 30000
        // });
        // Duration and positions needs to be configurable
    }
    copyMessage(val) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        // selBox.value = $(val).text();
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.openSnackBar('Copied to clipboard.', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }
    hasPartnerInfoPermission(partnerInfo) {
        switch (partnerInfo) {
            case 'Email':
                return this.accountInfoService.hasPermission('VIEW_PRIMARY_EMAIL_PARTNER_DETAILS');
            case 'Partner Short Code':
                return this.accountInfoService.hasPermission('VIEW_PARTNER_SHORTCODE_PARTNER_DETAILS');
            case 'Partner Key':
                return this.accountInfoService.hasPermission('VIEW_PARTNER_KEY_PARTNER_DETAILS');
            case 'API Key':
                return this.accountInfoService.hasPermission('VIEW_API_KEY_PARTNER_DETAILS');
        }
    }
    hignlightSelection(index, id, menus) {
        let flagid: any;
        for (let i = 0; i < menus.length; i++) {
            if ($('#' + id + i).hasClass('selectedClass')) {
                flagid = i;
                $('#' + id + i).removeClass('selectedClass');
            }
        }
        if (index !== flagid) {
            $('#' + id + index).addClass('selectedClass');
        }

    }

    async ngOnInit() {
        if (this.platform.availableEnvironmentsToSwitch) {
            this.availableEnvironmentsToSwitch = this.platform.availableEnvironmentsToSwitch;
        } else {
            this.platform.getEnvironments();
        }

        if (this.platform.settingsData !== null && this.platform.settingsData !== undefined) {
            this.settingsData = this.platform.settingsData['body'][0];
            this.settingsLoading = false;
            this.checkServerStatus();
        } else {
            await this.confPost.getSettingsV2CRUD(this.accountInfoService.partner, this.accountInfoService.account, false).subscribe(response => {
                if (response['body'] && response['body'][0]) {
                    this.platform.settingsData = response;
                    this.settingsData = response['body'][0];
                    this.settingsLoading = false;
                    this.checkServerStatus();
                }
            });
        }

        const permissionSubscription = interval(500).subscribe((async x => {
            permissionSubscription.unsubscribe();
            if (this.platform.hasPlatformPermission('VIEW_ALERTS')) {
                this.alertService.alertRefreshListener.emit({action: 'init'});
            }
        }));

        const adminEnvironmentSettingsSubscription = interval(500).subscribe((async x => {
            if (this.adminEnvironmentHandler.hasAdminEnvironmentSettingsDataSet()) {
                adminEnvironmentSettingsSubscription.unsubscribe();
                this.allEnvironments = this.adminEnvironmentHandler.allEnvironments;
                this.isEnvironmentSwitchLoading = false;
            } else {
                this.isEnvironmentSwitchLoading = true;
            }
        }));

        // this.partnerShortCode = this.accountInfoService.partnerShortCode;
        // await this.authedAPIService.getPartnerEnvironments(this.partnerShortCode).subscribe(response => {
        //     if (response) {
        //         this.allEnvironments = response;
        //         this.adminEnvironmentHandler.currentEnvironment = this.allEnvironments[0];
        //     }
        // });
    }

    async checkServerStatus() {
        this.serverStatusData = [];
        for (const env of this.settingsData['environments']) {
            if (env['name'] === this.accountInfoService.partner) {
                const services = env['services'].filter(element => element.type === 'dashboard' || element.type === 'devex' || element.type === 'storage' || element.type === 'apigateway');

                for (const service of services) {
                    if (service.configurations) {
                        for (const configuration of service.configurations) {
                            if (configuration.status) {
                                // active = await this.urlExists(configuration.url);
                                const url = service.type === 'storage' ? configuration.url : 'https://' + configuration.url
                                if (service.type !== 'apigateway') {
                                    this.urlExists(url).then(result =>
                                        this.serverStatusData.push({
                                            name: service.name,
                                            subName: configuration.url,
                                            active: result,
                                            disabled: !configuration.status,
                                            link: url
                                        })
                                    );
                                } else {
                                    if (configuration.url && configuration.url.length > 0) {
                                        this.urlExists('https://' + configuration.url[0]).then(result =>
                                            this.serverStatusData.push({
                                                name: 'API Gateway',
                                                subName: configuration.url,
                                                active: result,
                                                disabled: !configuration.status,
                                                link: ''
                                            })
                                        );
                                    } else {
                                        this.serverStatusData.push({
                                            name: 'API Gateway',
                                            subName: configuration.url,
                                            active: false,
                                            disabled: !configuration.status,
                                            link: ''
                                        });
                                    }
                                }
                            } else {
                                this.serverStatusData.push({
                                    name: service.name,
                                    subName: configuration.url,
                                    active: false,
                                    disabled: !configuration.status,
                                    link: '',
                                });
                            }
                        }
                    }
                }
            }
        }
    }

    // getServersStatus() {
    //     let itemCount = 0;
    //     let activeCount = 0;
    //     for (const item of this.serverStatusData) {
    //         if (!item.disabled) {
    //             itemCount++;
    //             if (item.active) {
    //                 activeCount++;
    //             }
    //         }
    //     }
    //     if (activeCount === 0 && itemCount > 0) {
    //         return 'svri-r';
    //     } else if (activeCount === itemCount) {
    //         return 'svri-g';
    //     } else if (activeCount > 0 && itemCount > 0) {
    //         return 'svri-y';
    //     } else {
    //         return '';
    //     }
    // }

    urlExists(url) {
        return fetch(url, {mode: 'no-cors'})
            .then(res => true)
            .catch(err => err.status);
    }

    ngOnChanges(): void {
        if (!(this.platform.availableEnvironmentsToSwitch) && this.isUserLoggedIn === 'true') {
            this.platform.getEnvironments();
        }
    }

    logout() {
        if (confirm('Are you sure you want to logout?')) {
            this.authService.logout();
            const log_payload = {
                logType: 'INFO',
                logLevel: 0,
                slugSearch: '',
                label: 'BUTTON_CLICK',
                featureArea: 'HEADER_PANEL',
                resource: 'LOGOUT',
                action: 'CLICK',
                result: 'SUCCESS',
                payload: '',
                responseStatusCode: '200',
                response: '',
                errorMessage: '',
                logMessage: 'Successfully logged out'
            };
            this.auditLog.log(log_payload);
        }
    }
    getNotification() {

        this.confPost.getData('services', 'services', 'v1', 'notification', null).subscribe(response => {
            this.notificationList = response;
        });
    }

    openSwitchToDialog(environmentObject) {
        if (this.platform.hasPlatformPermission('CHANGE_ENVIRONMENTS_SWITCH_TO')) {
            const confirm = this.dialog.open(ConfirmSwitchingComponent, {
                width: '70vh',
            });
            confirm.afterClosed().subscribe(acceptance => {
                if (acceptance === 'yes') {
                    const dialogRef = this.dialog.open(SwitchEnvironmentComponent, {
                        width: '75vh',
                        data: environmentObject
                    });
                }
            });
        } else {
            alert('Permission denied to switch environments');
        }
    }

    closeSideNav(sidePanel) {
        if (sidePanel === 'notifications') {
            this.isNotificationPanelOpened = false;
        } else if (sidePanel === 'serverstatus') {
            this.isServerStatusPanelOpened = false;
        } else if (sidePanel === 'partnerinfo') {
            this.isPartnerInfoPanelOpened = false;
        } else if (sidePanel === 'alerts') {
            this.isAlertsPanelOpened = false;
        }
    }

    toggleSideNav(sidePanel) {
        // this.isSideNavOpened = !this.isSideNavOpened;
        if (sidePanel === 'notifications') {
            this.isNotificationPanelOpened = !this.isNotificationPanelOpened;
            if (this.isNotificationPanelOpened) {
                this.isNotificationPanelStateChanged.emit();
            }
        } else if (sidePanel === 'serverstatus') {
            this.isServerStatusPanelOpened = !this.isServerStatusPanelOpened;
            if (this.isServerStatusPanelOpened) {
                this.isServerStatusPanelStateChanged.emit();
            }
        } else if (sidePanel === 'partnerinfo') {
            this.partnerInfo = [
                {
                    title: 'Email',
                    value: this.accountInfoService.email,
                    icon: 'fa fa-envelope',
                    showCopy: false
                },
                {
                    title: 'Partner Short Code',
                    value: this.accountInfoService.partner,
                    icon: 'fa fa-user',
                    showCopy: false
                },
                {
                    title: 'Partner Key',
                    value: this.accountInfoService.partnerKey,
                    icon: 'fa fa-key',
                    showCopy: true
                },
                {
                    title: 'API Key',
                    value: this.accountInfoService.kongApiKey,
                    icon: 'fa fa-key',
                    showCopy: true
                }
            ];
            this.isPartnerInfoPanelOpened = !this.isPartnerInfoPanelOpened;
            if (this.isPartnerInfoPanelOpened) {
                this.isPartnerInfoStatusPanelStateChanged.emit();
            }
        } else if (sidePanel === 'alerts') {
            this.isAlertsPanelOpened = !this.isAlertsPanelOpened;
            if (this.isAlertsPanelOpened) {
                this.isAlertsPanelStateChanged.emit();
            }
        }
    }
    moveCarousel(direction: string, event: Event): void {
        const carouselContainer = document.getElementById('carouselContent');
        const cardWidth = 100; 
        const scrollAmount = direction === 'left' ? -cardWidth : cardWidth;    
        carouselContainer.scrollLeft += scrollAmount;
        event.stopPropagation();   
        
      }    
}

@Component({
    selector: 'app-confirm-switching',
    templateUrl: 'confirm-switching.component.html',
    styleUrls: ['confirm-switching.component.css']
})
export class ConfirmSwitchingComponent implements OnInit {

    constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<ConfirmSwitchingComponent>) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {
    }

    close(acceptance) {
        this.dialogRef.close(acceptance);
    }


}

@Component({
    selector: 'switch-environment',
    templateUrl: 'switch-environment.component.html',
    styleUrls: ['switch-environment.component.css']
})
export class SwitchEnvironmentComponent implements OnInit {

    password = '';
    confirmPassword = '';
    hide = true;
    confirmHide = true;
    passwordValidationStatement = '';
    flag = false;
    loading = false;
    captchaKey = '6LeiA80UAAAAAK-P15G3dY3V_KOkzTZrUG4NLAWj';
    captcha: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                public dialog: MatDialog,
                public platform: LeftpanelComponent,
                private authService: AuthService,
                public dialogRef: MatDialogRef<SwitchEnvironmentComponent>,
                public confPost: ConfService) {
    }

    ngOnInit() {
        // if (this.captchaKey === null || this.captchaKey === undefined) {
        this.confPost.getCaptchaSiteKey().subscribe(response => {
            if (response && response[0]) {
                this.captchaKey = response[0]['value'];
            }
        });
        // }
    }

    close() {
        this.dialogRef.close();
    }

    resolved(captchaResponse: string) {
        this.captcha = captchaResponse;
    }

    switchEnvironment() {
        this.loading = true;
        if (!this.password || this.password === '') {
            this.loading = false;
            this.platform.openSnackBar('Please enter a password.', 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        } else {
            if (this.captcha) {
                Promise.resolve(this.authService.generateAuthenticatorToken(this.data['environmentName'], this.password)).then(response => {

                    let authTokenContainer: any;
                    authTokenContainer = response;
                    Promise.resolve(this.platform.validateDNS([authTokenContainer.partner + '.apiplatform.io'])).then(resp1 => {
                        const verified = (resp1 === 'verified');
                        this.authService.redirectWithAuthenticatorToken(verified, authTokenContainer.partner, authTokenContainer.token);
                    }, error => {
                        this.authService.redirectWithAuthenticatorToken(false, authTokenContainer.partner, authTokenContainer.token);
                    });
                    this.loading = false;
                }, error => {
                    this.loading = false;
                    this.platform.openSnackBar(error, 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            } else {
                this.loading = false;
                this.platform.openSnackBar('Please perform captcha action to proceed to switching environments.', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }
    }
}
